import { useQuery } from 'react-query';
import axios from 'axios';
import { useTokenStore } from '../../storage/tokenState';
import { GET_PLAN_STATE_V3 } from '../../appConstants/APIEndpoint';
import { LANGUAGE } from '../../constant';
import { getSubscriptionBaseUrl } from '../../utils/apiConfig';

interface PlanStateResponse {
  en: string;
  response: {
    success: boolean;
    data?: {
      inactiveFreePlanState?: {
        planId?: string;
        webView?: {
          trialAmount?: string;
          startDate?: string;
          planAmount?: string;
          validityValue?: string;
          validityUnit?: string;
        };
      };
      inactivePaidPlanState?: {
        planData?: {
          plans?: Array<{
            id: string;
            validityValue: { text: string };
            planValue: { text: string };
            strikePrice: { text: string };
            actualPriceAmount: number;
            actualPrice: { text: string };
            isSelected: boolean;
            timeline: {
              startDate: string;
              endDate: string;
            };
          }>;
        };
      };
    };
  };
}

export const useGetPlanStateV3 = (enabled: boolean = true) => {
  const { token } = useTokenStore();

  const { data, isLoading, error } = useQuery<PlanStateResponse>(
    ['planStateV3'],
    async () => {
      // Get base URL from environment (trailing slash already removed in apiConfig)
      const baseUrl = getSubscriptionBaseUrl();
      const fullUrl = `${baseUrl}${GET_PLAN_STATE_V3.url}`;
      
      console.log('Calling getPlanStateV3 API:', {
        url: fullUrl,
        hasToken: !!token?.accessToken
      });

      const response = await axios.post(fullUrl, {}, {
        headers: {
          'Accept': 'application/json',
          'Authorization': token?.accessToken || '',
          'x-zupee-source': 'web',
          // 'x-zupee-env': 'cse',
          // "z-stage-env-id":"stv-prya80a3bac",
          'language': localStorage.getItem("language") || LANGUAGE,
          'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
          'appname': process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',
        }
      });

    //   if (response?.data?.response?.data?.inactiveFreePlanState) {
    //       response.data.response.data.inactiveFreePlanState.webView = {
    //           trialAmount: "₹2",
    //           startDate: "7 Nov, 2025",
    //           planAmount: "₹199",
    //           validityValue: "90",
    //           validityUnit: "days"
    //         };
    //     }
        console.log('getPlanStateV3 Response:', response.data);
      return response.data;
    },
    {
      enabled: enabled && !!token?.accessToken,
      retry: 1,
      staleTime: 30000,
    }
  );

 
 

  return {
    planStateData: data,
    isLoading,
    error
  };
};

